import { capitalize } from 'vue';

import i18n from '@/vueI18n';

export default class DefaultValidator {
  public static required(value?): { required: string } | null {
    if (value == null || value === '') {
      return { required: capitalize(i18n.global.t('messages.requiredField')) };
    }
    return null;
  }
}
